import { AnimatePresence, motion } from "framer-motion";

import styles from "./Transition.module.scss";

export interface TransitionProps {
  children: JSX.Element;
}

export const Transition = ({ children }: TransitionProps) => {
  return (
    <AnimatePresence>
      <motion.div
        className={styles.transitionWrapper}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
